module.exports = __webpack_public_path__ + "img/37.77798d73.jpg";